(function () {
  'use strict';

  var CONFIG = {
    excludedPaths: ['/pages/total-immersion', '/pages/pilot-project'],
    ctaUrl: 'https://kanban.plus/pages/total-immersion'
      + '?utm_source=sidebar_tab'
      + '&utm_medium=promo'
      + '&utm_campaign=ti_2026',
    ctaUrlMobile: 'https://kanban.plus/pages/total-immersion'
      + '?utm_source=mobile_bar'
      + '&utm_medium=promo'
      + '&utm_campaign=ti_2026',
    entryDelay: 400,
    seenKey: 'kp_ti_seen',
    ctaSessionKey: 'kp_ti_learn_more_clicked',
    heroImg: 'https://cdn.shopify.com/s/files/1/0729/3049/2741/files/TI-img-noshadow_52394463.png?v=1790682121',
    logoImg: 'https://cdn.shopify.com/s/files/1/0729/3049/2741/files/dja-school-of-management-logo_8fa2336c.png?v=1790682119',
  };

  // Storage access can throw in Safari Private Browsing, sandboxed iframes,
  // and some in-app browsers (Instagram/Facebook/TikTok) that restrict it —
  // an uncaught exception here would silently kill the entire script.
  function safeStorageGet(type, key) {
    try {
      return (type === 'session' ? window.sessionStorage : window.localStorage).getItem(key);
    } catch (e) {
      return null;
    }
  }
  function safeStorageSet(type, key, value) {
    try {
      (type === 'session' ? window.sessionStorage : window.localStorage).setItem(key, value);
    } catch (e) {
      // storage blocked — degrade gracefully, don't crash
    }
  }

  var path = window.location.pathname;
  var isExcludedPage = CONFIG.excludedPaths.some(function (excludedPath) {
    return path === excludedPath || path.indexOf(excludedPath + '/') === 0;
  });
  var isMobileViewport = window.matchMedia('(max-width: 767px)').matches;
  if (isExcludedPage || (isMobileViewport && safeStorageGet('session', CONFIG.ctaSessionKey))) return;


  function init() {

  // ─── CSS ──────────────────────────────────────────────────────────────────
  var css = [
    '@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap");',

    /* Root wrapper */
    '#kp-ti-root {',
    '  position: fixed;',
    '  left: 0;',
    '  top: 50%;',
    '  transform: translateY(-50%);',
    '  z-index: 2147483647;',
    '  display: flex;',
    '  align-items: stretch;',
    '  font-family: "Poppins", -apple-system, sans-serif;',
    '  opacity: 0;',
    '  transition: opacity 500ms cubic-bezier(0.23,1,0.32,1);',
    '}',
    '#kp-ti-root.kp-visible { opacity: 1; }',

    /* Panel */
    '#kp-ti-panel {',
    '  width: 0;',
    '  overflow: hidden;',
    '  transition: width 320ms cubic-bezier(0.23,1,0.32,1);',
    '  background: #fff;',
    '  border-radius: 0 20px 20px 0;',
    '  border-top: 1.5px solid rgba(91,63,187,0.14);',
    '  border-right: 1.5px solid rgba(91,63,187,0.14);',
    '  border-bottom: 1.5px solid rgba(91,63,187,0.14);',
    '  border-left: none;',
    '  box-shadow: none;',
    '  display: flex;',
    '  flex-direction: column;',
    '  box-sizing: border-box;',
    '  position: relative;',
    '}',
    '#kp-ti-panel.kp-open {',
    '  width: 700px;',
    '  box-shadow: 6px 0 40px rgba(91,63,187,0.18);',
    '}',
    '#kp-ti-backdrop {',
    '  position: fixed;',
    '  inset: 0;',
    '  background: rgba(10,8,20,0);',
    '  pointer-events: none;',
    '  transition: background 320ms ease;',
    '  z-index: 2147483646;',
    '}',
    '#kp-ti-backdrop.kp-open { background: rgba(10,8,20,0.45); pointer-events: auto; }',
    '#kp-ti-close {',
    '  position: absolute;',
    '  top: 12px;',
    '  right: 14px;',
    '  width: 24px;',
    '  height: 24px;',
    '  display: flex;',
    '  align-items: center;',
    '  justify-content: center;',
    '  background: none;',
    '  border: none;',
    '  cursor: pointer;',
    '  color: #aaa;',
    '  font-size: 18px;',
    '  line-height: 1;',
    '  padding: 0;',
    '  z-index: 10;',
    '  transition: color 160ms ease, transform 160ms ease;',
    '}',
    '#kp-ti-close:hover { color: #555; transform: scale(1.15); }',

    '#kp-ti-inner {',
    '  display: flex;',
    '  min-width: 700px;',
    '  height: 100%;',
    '}',

    /* Image column */
    '#kp-ti-img-col {',
    '  width: 320px;',
    '  flex-shrink: 0;',
    '  background: linear-gradient(160deg,#c4b5f4 0%,#b8a9f0 35%,#c9b8f8 65%,#e0c4f8 100%);',
    '  display: flex;',
    '  align-items: center;',
    '  justify-content: center;',
    '  padding: 20px 16px;',
    '  overflow: hidden;',
    '}',
    '#kp-ti-img-col img {',
    '  width: 100%;',
    '  height: auto;',
    '  display: block;',
    '  border-radius: 8px;',
    '  object-fit: cover;',
    '  filter: drop-shadow(0 8px 28px rgba(20,16,30,0.22));',
    '}',

    /* Content column */
    '#kp-ti-content {',
    '  flex: 1;',
    '  min-width: 0;',
    '  padding: 20px 22px 20px;',
    '  display: flex;',
    '  flex-direction: column;',
    '  gap: 0;',
    '  overflow: hidden;',
    '}',

    /* ── SECTION 1: Header (logo + badge) ── */
    '#kp-ti-header {',
    '  display: flex;',
    '  align-items: center;',
    '  gap: 6px;',
    '  margin-bottom: 12px;',
    '}',
    '#kp-ti-logo { height: 26px; width: auto; }',
    '#kp-ti-tag {',
    '  display: inline-flex;',
    '  align-items: center;',
    '  background: linear-gradient(90deg,#5B3FBB 0%,#744cf3 100%);',
    '  color: #fff;',
    '  font-size: 9px;',
    '  font-weight: 700;',
    '  letter-spacing: 0.12em;',
    '  text-transform: uppercase;',
    '  padding: 3px 9px;',
    '  border-radius: 100px;',
    '}',

    /* ── SECTION 2: Title block ── */
    '#kp-ti-title {',
    '  font-size: 22px;',
    '  font-weight: 800;',
    '  color: #0F0F14;',
    '  line-height: 1.15;',
    '  letter-spacing: -0.02em;',
    '  margin-bottom: 4px;',
    '}',
    '#kp-ti-title .kp-grad {',
    '  background: linear-gradient(90deg,#744cf3 0%,#9B6BFF 55%,#C084FC 100%);',
    '  -webkit-background-clip: text;',
    '  -webkit-text-fill-color: transparent;',
    '  background-clip: text;',
    '}',
    '#kp-ti-platform-line {',
    '  font-size: 13px;',
    '  color: #9090A8;',
    '  font-weight: 400;',
    '  margin-bottom: 2px;',
    '}',
    '#kp-ti-sub {',
    '  font-size: 13px;',
    '  color: #9090A8;',
    '  font-weight: 400;',
    '  margin-bottom: 14px;',
    '}',

    /* ── SECTION 3: Facts ── */
    '.kp-ti-divider { height: 1px; background: rgba(91,63,187,0.09); margin-bottom: 12px; }',
    '#kp-ti-facts { display: flex; flex-direction: column; gap: 7px; margin-bottom: 14px; }',
    '.kp-ti-fact { display: flex; align-items: center; gap: 8px; font-size: 13px; color: #2A2A3A; }',
    '.kp-ti-dot { width: 6px; height: 6px; border-radius: 50%; background: linear-gradient(135deg,#744cf3,#C084FC); flex-shrink: 0; }',
    '.kp-ti-fact em { font-style: normal; color: #5B3FBB; font-weight: 700; }',
    '.kp-ti-fact.kp-free { align-items: flex-start; }',
    '.kp-ti-fact.kp-free .kp-ti-dot { margin-top: 4px; }',
    '.kp-free-word { color: #16A34A; font-weight: 800; }',
    '.kp-new-badge { display: inline-block; margin-left: 3px; background: #F05A28; color: #fff; font-size: 8px; font-weight: 800; letter-spacing: 0.04em; padding: 1px 5px; border-radius: 6px; vertical-align: 1px; }',

    /* ── SECTION 4: Price ── */
    '#kp-ti-price-block { margin-bottom: 12px; }',
    '#kp-ti-price-note { font-size: 11px; color: #9090A8; line-height: 1.3; margin-bottom: 4px; }',
    '#kp-ti-price-note strong { color: #5B3FBB; font-weight: 700; }',
    '#kp-ti-price-row { display: flex; align-items: baseline; gap: 7px; }',
    '#kp-ti-price-label { font-size: 12px; color: #AAAABC; font-weight: 400; }',
    '#kp-ti-price { font-size: 32px; font-weight: 800; color: #5B3FBB; letter-spacing: -0.03em; line-height: 1; }',
    '#kp-ti-price-save { font-size: 11px; color: #AAAABC; margin-top: 3px; }',
    '#kp-ti-price-save strong { color: #F05A28; font-weight: 600; }',

    /* ── SECTION 5: CTA (full width, prominent) ── */
    '#kp-ti-cta {',
    '  display: flex;',
    '  align-items: center;',
    '  justify-content: center;',
    '  gap: 7px;',
    '  background: #7C5CE8;',
    '  color: #fff;',
    '  font-family: inherit;',
    '  font-size: 16px;',
    '  font-weight: 500;',
    '  width: 200px;',
    '  height: 40px;',
    '  margin: 0 auto;',
    '  border-radius: 999px;',
    '  border: 1px solid #fff;',
    '  box-shadow: 0 0 4px 2px rgba(90,85,201,0.3);',
    '  text-decoration: none;',
    '  white-space: nowrap;',
    '  transition: all 0.18s cubic-bezier(0.23,1,0.32,1);',
    '  letter-spacing: 0.01em;',
    '}',
    '#kp-ti-cta:hover {',
    '  background: linear-gradient(90deg,#744cf3 0%,#9B6BFF 55%,#C084FC 100%);',
    '  box-shadow: 0 0 4px 2px rgba(90,85,201,0.3);',
    '  transform: translateY(-1px);',
    '}',
    '#kp-ti-cta svg { transition: transform 0.18s ease; }',
    '#kp-ti-cta:hover svg { transform: translateX(3px); }',

    /* ── Tab ── */
    '#kp-ti-tab {',
    '  writing-mode: vertical-lr;',
    '  text-orientation: mixed;',
    '  background: #7C5CE8;',
    '  color: #fff;',
    '  border: none;',
    '  border-radius: 0 12px 12px 0;',
    '  padding: 22px 12px;',
  '  font-size: 13px;',
    '  font-weight: 600;',
  '  letter-spacing: 0.12em;',
    '  text-transform: uppercase;',
    '  cursor: pointer;',
    '  font-family: inherit;',
    '  box-shadow: 3px 0 18px rgba(91,63,187,0.3);',
    '  white-space: nowrap;',
    '  display: flex;',
    '  align-items: center;',
    '  justify-content: center;',
    '  transition: background 160ms, box-shadow 160ms, opacity 200ms;',
    '  flex-shrink: 0;',
    '}',
    '#kp-ti-tab.kp-hidden { opacity: 0; pointer-events: none; }',
    '#kp-ti-tab:hover { background: linear-gradient(180deg,#744cf3 0%,#9B6BFF 100%); box-shadow: 3px 0 24px rgba(116,76,243,0.45); }',

    /* ── Mobile: hide desktop root, show sticky bottom bar ── */
    '@media (max-width: 767px) {',
    '  #kp-ti-root { display: none !important; }',
    '}',

    '#kp-ti-mobile-bar {',
    '  display: none;',
    '  position: fixed;',
    '  bottom: 0;',
    '  left: 0;',
    '  right: 0;',
    '  z-index: 2147483647;',
    '  background: linear-gradient(90deg,#5B3FBB 0%,#744cf3 100%);',
    '  font-family: "Poppins", -apple-system, sans-serif;',
    '  padding: 10px 14px calc(10px + env(safe-area-inset-bottom));',
    '  min-height: 108px;',
    '  box-sizing: border-box;',
    '  align-items: center;',
    '  justify-content: space-between;',
    '  gap: 12px;',
    '  box-shadow: 0 -4px 20px rgba(91,63,187,0.3);',
    '  opacity: 0;',
    '  transform: translateY(100%);',
    '  transition: opacity 400ms cubic-bezier(0.23,1,0.32,1), transform 400ms cubic-bezier(0.23,1,0.32,1);',
    '}',
    '#kp-ti-mobile-bar.kp-visible {',
    '  opacity: 1;',
    '  transform: translateY(0);',
    '}',
    '@media (max-width: 767px) {',
    '  #kp-ti-mobile-bar { display: flex; }',
    '}',

    '#kp-ti-mob-left {',
    '  display: flex;',
    '  flex-direction: column;',
    '  gap: 2px;',
    '  flex: 1;',
    '  min-width: 0;',
    '}',
    '#kp-ti-mob-brand { display: flex; align-items: center; gap: 7px; min-height: 17px; margin-bottom: 3px; }',
    '#kp-ti-mob-logo { height: 16px; width: auto; max-width: 92px; object-fit: contain; border-radius: 2px; }',
    '#kp-ti-mob-tag { display: inline-flex; align-items: center; height: 16px; padding: 0 5px; border: 1px solid rgba(255,255,255,0.34); border-radius: 999px; color: #fff; background: rgba(255,255,255,0.13); font-size: 7px; font-weight: 700; letter-spacing: 0.06em; white-space: nowrap; }',
    '#kp-ti-mob-title {',
    '  font-size: 14px;',
    '  font-weight: 700;',
    '  color: #fff;',
    '  white-space: nowrap;',
    '  overflow: hidden;',
    '  text-overflow: ellipsis;',
    '}',
    '#kp-ti-mob-title strong { color: #F0E9FF; }',
    '#kp-ti-mob-context { font-size: 10px; font-weight: 700; color: #FFE9B0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }',
    '#kp-ti-mob-courses { font-size: 10px; font-weight: 400; color: rgba(255,255,255,0.78); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }',
    '#kp-ti-mob-sub { font-size: 12px; font-weight: 600; color: #fff; white-space: nowrap; }',

    '#kp-ti-mob-cta {',
    '  display: inline-flex;',
    '  align-items: center;',
    '  gap: 5px;',
    '  background: #fff;',
    '  color: #5B3FBB;',
    '  font-family: inherit;',
    '  font-size: 12px;',
    '  font-weight: 700;',
    '  height: 38px;',
    '  padding: 0 13px;',
    '  border-radius: 999px;',
    '  border: 1px solid rgba(91,63,187,0.12);',
    '  box-shadow: 0 2px 7px rgba(34,21,80,0.16);',
    '  text-decoration: none;',
    '  white-space: nowrap;',
    '  flex-shrink: 0;',
    '  transition: all 0.18s cubic-bezier(0.23,1,0.32,1);',
    '}',
    '#kp-ti-mob-cta:hover { background: rgba(255,255,255,0.9); transform: translateY(-1px); }',
  ].join('\n');

  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  // ─── DOM ──────────────────────────────────────────────────────────────────
  var root = document.createElement('div');
  root.id = 'kp-ti-root';

  var panel = document.createElement('div');
  panel.id = 'kp-ti-panel';
  var closeBtn = document.createElement('button');
  closeBtn.id = 'kp-ti-close';
  closeBtn.innerHTML = '&#x2715;';
  closeBtn.setAttribute('aria-label', 'Close');

  var inner = document.createElement('div');
  inner.id = 'kp-ti-inner';

  // ── Image column ──
  var imgCol = document.createElement('div');
  imgCol.id = 'kp-ti-img-col';
  var img = document.createElement('img');
  img.src = CONFIG.heroImg;
  img.alt = 'Kanban+ Total Immersion';
  imgCol.appendChild(img);
  inner.appendChild(imgCol);

  // ── Content column ──
  var content = document.createElement('div');
  content.id = 'kp-ti-content';

  // SECTION 1 — Header (logo + badge)
  var header = document.createElement('div');
  header.id = 'kp-ti-header';
  var logo = document.createElement('img');
  logo.id = 'kp-ti-logo';
  logo.src = CONFIG.logoImg;
  logo.alt = 'David J Anderson School of Management';
  var tag = document.createElement('span');
  tag.id = 'kp-ti-tag';
  tag.textContent = 'SPECIAL OFFER';
  header.appendChild(logo);
  header.appendChild(tag);
  content.appendChild(header);

  // SECTION 2 — Title + subtitles
  var title = document.createElement('div');
  title.id = 'kp-ti-title';
  title.innerHTML = 'Kanban+ <span class="kp-grad">Total Immersion</span>';
  content.appendChild(title);

  var platformLine = document.createElement('div');
  platformLine.id = 'kp-ti-platform-line';
  platformLine.textContent = 'Training inside the platform';
  content.appendChild(platformLine);

  var sub = document.createElement('div');
  sub.id = 'kp-ti-sub';
  sub.textContent = 'Choose from 6 Courses';
  content.appendChild(sub);

  // SECTION 3 — Facts (key selling points)
  content.appendChild(Object.assign(document.createElement('div'), { className: 'kp-ti-divider' }));

  var facts = document.createElement('div');
  facts.id = 'kp-ti-facts';
  [
    { parts: ['Taught by ', 'David Anderson'], free: false },
    { parts: ['Official ', 'Kanban University', ' credentials'], free: false },
    { parts: ['Hands-on inside ', 'Kanban+'], free: false },
    { html: '<em>Flow Manager</em> or <em>Portfolio Manager</em><span class="kp-new-badge">NEW</span><br>is <span class="kp-free-word">FREE</span>', free: true },
  ].forEach(function (item) {
    var f = document.createElement('div');
    f.className = 'kp-ti-fact' + (item.free ? ' kp-free' : '');
    var dot = document.createElement('span');
    dot.className = 'kp-ti-dot';
    f.appendChild(dot);
    var txt = document.createElement('span');
    txt.innerHTML = item.html || (item.parts[0] + '<em>' + item.parts[1] + '</em>' + (item.parts[2] || ''));
    f.appendChild(txt);
    facts.appendChild(f);
  });
  content.appendChild(facts);

  // SECTION 4 — Price
  content.appendChild(Object.assign(document.createElement('div'), { className: 'kp-ti-divider' }));

  var priceBlock = document.createElement('div');
  priceBlock.id = 'kp-ti-price-block';
  priceBlock.innerHTML =
    '<div id="kp-ti-price-note">For <strong>Kanban+</strong> subscribers</div>'
    + '<div id="kp-ti-price-row">'
    +   '<span id="kp-ti-price-label">From</span>'
    +   '<span id="kp-ti-price">\u20ac399</span>'
    + '</div>'
    + '<div id="kp-ti-price-save">Save up to <strong>\u20ac3,600</strong></div>';
  content.appendChild(priceBlock);

  // SECTION 6 — CTA (full width, most prominent)
  var cta = document.createElement('a');
  cta.id = 'kp-ti-cta';
  cta.href = CONFIG.ctaUrl;
  cta.innerHTML = 'Learn more'
    + '<svg width="12" height="12" viewBox="0 0 14 14" fill="none">'
    + '<path d="M2.5 7H11.5M11.5 7L7.5 3M11.5 7L7.5 11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>'
    + '</svg>';
  content.appendChild(cta);

  inner.appendChild(content);
  panel.appendChild(inner);
  panel.appendChild(closeBtn);
  root.appendChild(panel);

  // ── Vertical tab ──
  var tab = document.createElement('button');
  tab.id = 'kp-ti-tab';
  tab.setAttribute('aria-label', 'Total Immersion — see all classes');
  var tabText = document.createElement('span');
  tabText.textContent = 'Kanban+ Total Immersion';
  tab.appendChild(tabText);
  root.appendChild(tab);

  document.body.appendChild(root);

  // ── Mobile sticky bottom bar ──
  var mobBar = document.createElement('div');
  mobBar.id = 'kp-ti-mobile-bar';

  var mobLeft = document.createElement('div');
  mobLeft.id = 'kp-ti-mob-left';
  var mobBrand = document.createElement('div');
  mobBrand.id = 'kp-ti-mob-brand';
  var mobLogo = document.createElement('img');
  mobLogo.id = 'kp-ti-mob-logo';
  mobLogo.src = CONFIG.logoImg;
  mobLogo.alt = 'David J Anderson School of Management';
  var mobTag = document.createElement('span');
  mobTag.id = 'kp-ti-mob-tag';
  mobTag.textContent = 'SPECIAL OFFER';
  mobBrand.appendChild(mobLogo);
  mobBrand.appendChild(mobTag);
  var mobTitle = document.createElement('div');
  mobTitle.id = 'kp-ti-mob-title';
  mobTitle.innerHTML = 'Kanban+ <strong>Total Immersion</strong>';
  var mobContext = document.createElement('div');
  mobContext.id = 'kp-ti-mob-context';
  mobContext.textContent = 'Training inside the platform';
  var mobCourses = document.createElement('div');
  mobCourses.id = 'kp-ti-mob-courses';
  mobCourses.textContent = 'Choose from 7 Courses';
  var mobSub = document.createElement('div');
  mobSub.id = 'kp-ti-mob-sub';
  mobSub.textContent = 'From \u20ac399';
  mobLeft.appendChild(mobBrand);
  mobLeft.appendChild(mobTitle);
  mobLeft.appendChild(mobContext);
  mobLeft.appendChild(mobCourses);
  mobLeft.appendChild(mobSub);

  var mobCta = document.createElement('a');
  mobCta.id = 'kp-ti-mob-cta';
  mobCta.href = CONFIG.ctaUrlMobile;
  mobCta.innerHTML = 'Learn more'
    + '<svg width="10" height="10" viewBox="0 0 14 14" fill="none">'
    + '<path d="M2.5 7H11.5M11.5 7L7.5 3M11.5 7L7.5 11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>'
    + '</svg>';
  mobCta.addEventListener('click', function () {
    safeStorageSet('session', CONFIG.ctaSessionKey, '1');
  });


  mobBar.appendChild(mobLeft);
  mobBar.appendChild(mobCta);
  document.body.appendChild(mobBar);

  // ─── TOGGLE ───────────────────────────────────────────────────────────────
  var isOpen = false;
  var backdrop = document.createElement('div');
  backdrop.id = 'kp-ti-backdrop';
  document.body.insertBefore(backdrop, root);
  backdrop.addEventListener('click', closePanel);
  closeBtn.addEventListener('click', closePanel);

  function openPanel() {
    isOpen = true;
    panel.classList.add('kp-open');
    backdrop.classList.add('kp-open');
    tab.classList.add('kp-hidden');
  }
  function closePanel() {
    isOpen = false;
    panel.classList.remove('kp-open');
    backdrop.classList.remove('kp-open');
    tab.classList.remove('kp-hidden');
  }

  tab.addEventListener('click', function () {
    if (isOpen) { closePanel(); } else { openPanel(); }
  });
  document.addEventListener('mousedown', function (e) {
    if (isOpen && !root.contains(e.target)) closePanel();
  });

    setTimeout(function () {
      root.classList.add('kp-visible');
      mobBar.classList.add('kp-visible');
      var isFirstVisit = !safeStorageGet('local', CONFIG.seenKey);
      if (isFirstVisit) {
        safeStorageSet('local', CONFIG.seenKey, '1');
        openPanel();
      }
    }, window.KP_TI_DEMO_INSTANT ? 0 : (safeStorageGet('session', 'kp_ti_shown') ? CONFIG.entryDelay : 3000));
    safeStorageSet('session', 'kp_ti_shown', '1');

  } // end init()

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
